<div nz-row>
  <div class="hill-stepper" nz-col [nzSm]="{span: 24}" [nzMd]="{span: 14, offset: 5}" [nzLg]="{span: 10, offset: 7}">
    <nz-steps nzDirection="horizontal" [nzCurrent]="activeIndex" nzType="navigation"
        (nzIndexChange)="onFormStepClicked($event)">
        <nz-step nzTitle="Contact Details" nzIcon="icons/fontawesome/6.5.1/thin:user"></nz-step>
        <nz-step nzTitle="Address" nzIcon="icons/fontawesome/6.5.1/thin:house"></nz-step>
      </nz-steps>

      <form nz-form nzLayout="veritical" [formGroup]="contactForm" class="login-form" (ngSubmit)="onContinueToAddressTab()">
        <nz-form-item *ngIf="unknownErrorMessages.length > 0">
          <nz-alert nzType="error" *ngFor="let message of unknownErrorMessages" [nzMessage]="message" nzShowIcon>
          </nz-alert>
        </nz-form-item>
        <div *ngIf="activeIndex == 0">
          <mat-form-field id="registration-firstname-input" appearance="outline" subscriptSizing="dynamic" [ngClass]="{ 'warn': contactForm.get('firstName').value.length == firstNameMaxCharacters }">
            <mat-label>First Name</mat-label>
            <input type="text" matInput formControlName="firstName" required [maxLength]="firstNameMaxCharacters"/>
            @if (contactForm.get('firstName').value.length == firstNameMaxCharacters) {
              <mat-hint id="registration-firstname-warn">Maximum character limit reached</mat-hint>
            }
            @else if (contactForm.get('firstName').invalid) {
              <mat-error id="registration-firstname-error">{{ getErrorMessage('firstName') }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field id="registration-lastname-input" appearance="outline" subscriptSizing="dynamic" [ngClass]="{ 'warn': contactForm.get('lastName').value.length == lastNameMaxCharacters }">
            <mat-label>Last Name</mat-label>
            <input type="text" matInput formControlName="lastName" required [maxLength]="lastNameMaxCharacters"/>
            @if (contactForm.get('lastName').value.length == lastNameMaxCharacters) {
              <mat-hint id="registration-lastname-warn">Maximum character limit reached</mat-hint>
            }
            @if (contactForm.get('lastName').invalid) {
              <mat-error id="registration-lastname-error">{{ getErrorMessage('lastName') }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field id="registration-email-input" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Email</mat-label>
            <input type="email" matInput formControlName="email" autocomplete="email" required/>
            @if (contactForm.get('email').invalid) {
                <mat-error id="registration-email-error">{{ getErrorMessage('email') }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field id="registration-company-input" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Company</mat-label>
            <input type="text" matInput formControlName="company"/>
            @if (contactForm.get('company').invalid) {
              <mat-error id="registration-company-error">{{ getErrorMessage('company') }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field id="registration-mobilephone-input" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Mobile Phone</mat-label>
            <input type="text" matInput formControlName="mobilePhone" [maskito]="phoneOptions"/>
            @if (contactForm.get('mobilePhone').invalid) {
              <mat-error id="registration-mobilephone-error">{{ getErrorMessage('mobilePhone') }}</mat-error>
            }
          </mat-form-field>
          <div class="phone-extension-box">
            <div nz-row nzGutter="24">
              <div nz-col nzSpan="16">
                <mat-form-field id="registration-homephone-input" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Landline</mat-label>
                  <input type="text" matInput formControlName="homePhone" [maskito]="phoneOptions"/>
                  @if (contactForm.get('homePhone').invalid) {
                    <mat-error id="registration-homephone-error">{{ getErrorMessage('homePhone') }}</mat-error>
                  }
                </mat-form-field>
              </div>
              <div nz-col nzSpan="8">
                <mat-form-field id="registration-homephoneext-input" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Ext.</mat-label>
                  <input type="text" matInput formControlName="homePhoneExt"/>
                  @if (contactForm.get('homePhoneExt').invalid) {
                    <mat-error id="registration-homephoneext-error">{{ getErrorMessage('homePhoneExt') }}</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
          <mat-form-field id="registration-password-input" appearance="outline" class="password-control" subscriptSizing="dynamic">
            <mat-label>Password</mat-label>
            <input [type]="showPassword ? 'text' : 'password'" matInput formControlName="password" autocomplete="password" required/>
            <mat-icon matSuffix (click)="showPassword = !showPassword" id="registration-password-visibility-toggle">
                <i *ngIf="!showPassword" class="fa-solid fa-eye"></i>
                <i *ngIf="showPassword" class="fa-solid fa-eye-slash"></i>
            </mat-icon>
          </mat-form-field>
          <div class="password-policy">
            <ng-container 
                *ngIf="contactForm.get('password').dirty && contactForm.get('password').invalid" 
                [ngTemplateOutlet]="passwordError" 
                [ngTemplateOutletContext]="{ $implicit: contactForm.get('password') }"></ng-container>
              <ng-template #passwordError let-control>
                <div id="registration-password-error">
                  <ng-container *ngIf="control.hasError('required')">
                    Please choose your password.
                  </ng-container>
                  <ng-container *ngIf="control.hasError('minlength')">
                    Your password must be at least 8 characters.
                  </ng-container>
                  <ng-container *ngIf="control.hasError('passwordPolicyFail') && !control.hasError('required')">
                    <div>
                      Password must contain at least 3 of the following 4 types of characters:
                    </div>
                    <div class="password-policy-rule"
                      [ngClass]="control.getError('passwordPolicyFail').lowerCase ? 'success' : 'fail'">
                      <span nz-icon
                        [nzType]="control.getError('passwordPolicyFail').lowerCase ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                      Lower case letters (a-z)
                    </div>
                    <div class="password-policy-rule"
                      [ngClass]="control.getError('passwordPolicyFail').upperCase ? 'success' : 'fail'">
                      <span nz-icon
                        [nzType]="control.getError('passwordPolicyFail').upperCase ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                      Upper case letters (A-Z)
                    </div>
                    <div class="password-policy-rule"
                      [ngClass]="control.getError('passwordPolicyFail').numeric ? 'success' : 'fail'">
                      <span nz-icon
                        [nzType]="control.getError('passwordPolicyFail').numeric ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                      Numbers (0-9)
                    </div>
                    <div class="password-policy-rule"
                      [ngClass]="control.getError('passwordPolicyFail').specialChar ? 'success' : 'fail'">
                      <span nz-icon
                        [nzType]="control.getError('passwordPolicyFail').specialChar ? 'icons/fontawesome/solid:check' : 'icons/fontawesome/solid:times'"></span>
                      Special characters (e.g. !&#64;#$%^&* )
                    </div>
                  </ng-container>
                </div>
              </ng-template>
          </div>
          <mat-form-field id="registration-confirm-password-input" appearance="outline" class="password-control" subscriptSizing="dynamic">
            <mat-label>Confirm Password</mat-label>
            <input [type]="showConfirmPassword ? 'text' : 'password'" matInput formControlName="confirmPassword" autocomplete="password" required/>
            <mat-icon matSuffix (click)="showConfirmPassword = !showConfirmPassword" id="registration-confirm-password-visibility-toggle">
                <i *ngIf="!showConfirmPassword" class="fa-solid fa-eye"></i>
                <i *ngIf="showConfirmPassword" class="fa-solid fa-eye-slash"></i>
            </mat-icon>
            @if (contactForm.get('confirmPassword').invalid) {
                <mat-error id="registration-confirm-password-error">{{ getErrorMessage('confirmPassword') }}</mat-error>
            }
          </mat-form-field>
        <button 
          id="registration-continue-button" 
          class="hill-button-secondary continue-button" 
          type="submit" 
          [disabled]="isAuthenticating">
          <span class="loading-icon" *ngIf="isAuthenticating" nz-icon nzType="loading" nzTheme="outline"></span> Continue
        </button>
      </div>
      </form>
      <form nz-form [formGroup]="addressForm" class="address-form" (ngSubmit)="onCreateAccount()">
        <div *ngIf="activeIndex == 1">
          <div>
            <div class="form-group-box">
              <h4 nz-title>Delivery Address</h4>
            </div>
            <app-address-group #physicalAddress [addressType]="'physical'" [form]="addressForm"
              (onNzAddressSelected)="onPhysicalAddressSelected($event)"></app-address-group>
          </div>
          <div>
            <nz-divider></nz-divider>
            <div class="form-group-box">
              <h4 nz-title>Mailing Address</h4>
            </div>
            <nz-input-group>
              <label nz-checkbox [ngModel]="setAddressesSame$ | async" [ngModelOptions]="{standalone: true}"
                [nzDisabled]="(isSameAddressEnabled$ | async) !== true"
                (nzCheckedChange)="onIsPostalAddressSameAsPhysicalAddressChanged($event)">
                My Mailing Address is the same as my Delivery Address
              </label>
              <div class="same-address-info" *ngIf="(isSameAddressEnabled$ | async) !== true">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>&nbsp;
                <small>{{ sameAsAddressDisabledMessage }}</small>
              </div>
            </nz-input-group>
            <app-address-group #postalAddress [addressType]="'postal'" [form]="addressForm"
              [disabled]="(setAddressesSame$ | async)" (onNzAddressSelected)="onPostalAddressSelected($event)">
            </app-address-group>
          </div>
          <nz-form-item>
            <nz-form-control nzHasFeedback [nzErrorTip]="termsError">
              <nz-input-group>
                <label nz-checkbox id="registration-tcaccepted-checkbox" formControlName="portalTcAccepted" required>By
                  registering an account, you agree to
                  Hill Laboratories <u>
                    <a href="{{applicationConstants.OFFICIAL_PAGE}}/OnlineTerms" target="_blank"
                      (click)="$event.stopPropagation()">Online Terms &amp; Conditions</a></u>
                  and <u><a href="{{applicationConstants.OFFICIAL_PAGE}}/PrivacyStatement" target="_blank"
                      (click)="$event.stopPropagation()">Privacy Statement</a></u>.</label>
                <ng-template #termsError let-control>
                  <div id="registation-tcaccepted-error">
                    <ng-container *ngIf="control.hasError('required')">
                      Please accept the Online Terms &amp; Conditions and Privacy Statement
                    </ng-container>
                  </div>
                </ng-template>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
          <button 
            id="registration-create-button" 
            class="hill-button-secondary register-button" 
            type="submit" 
            [disabled]="isAuthenticating">
            <span class="loading-icon" *ngIf="isAuthenticating" nz-icon nzType="loading" nzTheme="outline"></span> 
              Register My Account
          </button>
        </div>
      </form>
      <nz-divider></nz-divider>
      <div class="form-section-helper-text">
          <span>Already have an account?</span>
      </div>
      <button 
        id="registration-login-button"
        class="hill-button-secondary-outline login-button"
        (click)="onLogin()">
        Log in
      </button>
  </div>
</div>